import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import promMaterialsListSaga from './sagas/faqContentsSearchSaga';
import faqContentsMenuListSaga from './sagas/faqContentsMenuListSaga';

export default [
  // Lists
  ...createCombineMapItem('faqContentsMenuList', createListReduceObject, [
    faqContentsMenuListSaga
  ]),
  ...createCombineMapItem('faqContentsSearchList', createListReduceObject, [
    promMaterialsListSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/reducers/static/lists/reducersMap.js